import { ChessPuzzle } from '@react-chess-puzzle-fix/react-chess-puzzle';
import { FaArrowRight, FaCheck, FaLightbulb, FaRedo } from 'react-icons/fa';
import { Button } from '../ui/button';

export default function PuzzleActions({ showRestart = true, showNext = false, nextPuzzle, onRestart, onNext, onDone }) {
  return (
    <div className="flex min-h-20 w-full items-center justify-center gap-3 px-4 py-4">
      {showRestart && (
        <ChessPuzzle.Reset asChild onReset={onRestart}>
          <Button variant="neutral" size="action" className="m-0 w-12 border-solid p-0" aria-label="Restart puzzle" title="Restart puzzle">
            <FaRedo aria-hidden="true" />
          </Button>
        </ChessPuzzle.Reset>
      )}
      <ChessPuzzle.Hint asChild>
        <Button variant="neutral" size="action" className="m-0 w-12 border-solid p-0" aria-label="Hint" title="Hint">
          <FaLightbulb aria-hidden="true" />
        </Button>
      </ChessPuzzle.Hint>
      {showNext && (
        <ChessPuzzle.Reset asChild puzzle={nextPuzzle} onReset={onNext}>
          <Button variant="brand" size="action" className="m-0 w-12 p-0" aria-label="Next puzzle" title="Next puzzle">
            <FaArrowRight aria-hidden="true" />
          </Button>
        </ChessPuzzle.Reset>
      )}
      {onDone && (
        <Button variant="brand" size="action" className="m-0 w-12 p-0" onClick={onDone} aria-label="Finish cycle" title="Finish cycle">
          <FaCheck aria-hidden="true" />
        </Button>
      )}
    </div>
  );
}
